
<span style="display:none">{{ title }} app is running!</span>
<app-top-bar></app-top-bar>
<div class="row-offcanvas row-offcanvas-left">
  <app-side-bar></app-side-bar>
  <div id="main">
    <div class="col-md-12">
      <div><router-outlet></router-outlet></div>
    </div>
  </div>
</div>
<footer>
  <div id="version">
    v{{currentAppVersion}}
  </div>
</footer>
